/**
 * Previous / Next pagination for server-side paginated tables. Uses opaque
 * `next_token`s (no page numbers) since DynamoDB Scan pagination is
 * forward-only. Keeps a local stack of previous tokens so the user can go
 * back.
 */

import React from 'react';
import Row from '@amzn/meridian/row';
import Button from '@amzn/meridian/button';
import Text from '@amzn/meridian/text';

export interface PaginationControlsProps {
  currentIndex: number;
  hasPrevious: boolean;
  hasNext: boolean;
  onPrevious: () => void;
  onNext: () => void;
  itemCount?: number;
  pageSize?: number;
}

export const PaginationControls: React.FC<PaginationControlsProps> = ({
  currentIndex,
  hasPrevious,
  hasNext,
  onPrevious,
  onNext,
  itemCount,
  pageSize,
}) => {
  return (
    <Row alignmentHorizontal="end" spacing="small">
      {typeof itemCount === 'number' && (
        <Text type="b200">
          Page {currentIndex + 1} — showing {itemCount}
          {pageSize ? ` of max ${pageSize}` : ''}
        </Text>
      )}
      <Button type="tertiary" onClick={onPrevious} disabled={!hasPrevious}>
        ← Previous
      </Button>
      <Button type="tertiary" onClick={onNext} disabled={!hasNext}>
        Next →
      </Button>
    </Row>
  );
};
